import React, { useState } from 'react';
import toast from 'react-hot-toast';
// import { db } from './Firebase';
// import {
//   setDoc,
//   collection,
//   getDocs,
//   query,
//   doc,
//   where,
// } from 'firebase/firestore';
import Instagram from '../assets/Instagram';
import Facebook from '../assets/Facebook';
import Tiktok from '../assets/Tiktok';
import { isValidEmail } from './Home';
import emailjs from '@emailjs/browser';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { useNavigate } from 'react-router-dom';
// import { useNavigate } from 'react-router-dom';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);
  const [didJoinNewsletter, setDidJoinNewsletter] = useState(false);
  const navigate = useNavigate();

  // const colRef = collection(db, 'newsletter_signups');
  // const navigate = useNavigate();

  // const signup = async () => {
  //   try {
  //     if (loading) return;
  //     if (!email.trim() || !name.trim() || !isValidEmail(email)) return;
  //     setLoading(true);
  //     const docSearch = await getDocs(
  //       query(colRef, where('email', '==', email))
  //     );
  //     if (docSearch.docs.length === 0) {
  //       await setDoc(doc(colRef), { email, name, entry_date: toDateTime() });
  //       emailjs
  //         .send(
  //           'service_h4br5is',
  //           'template_3bi0wub',
  //           { name, email },
  //           { publicKey: 'grg76XmeXnwqwv5cy' }
  //         )
  //         .then(
  //           (response) => {
  //             // window.location.replace("/thanks");
  //             navigate('/thanks');
  //             console.log('SUCCESS!', response.status, response.text);
  //           },
  //           (error) => {
  //             console.log('FAILED...', error);
  //             setLoading(false);
  //             toast('Error sending email', {
  //               icon: '⚠️',
  //             });
  //           }
  //         );
  //       //toast.success("Thank you for signing up!")
  //     } else {
  //       //console.log("Already exists");
  //       toast('You have already subscribed', {
  //         icon: '⚠️',
  //       });
  //       setLoading(false);
  //     }
  //   } catch (err) {
  //     toast.error('Request error');
  //     console.log(err);
  //     setLoading(false);
  //     toast('An error has occured', {
  //       icon: '⚠️',
  //     });
  //   }
  // };

  const joinNewsLetter = async () => {
    const _base_url = 'api';
    setLoading(true);
    const x = await fetch(
      `https://${_base_url}.thebooker.online/api/NewsLetter`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ name, email }),
      }
    );
    try {
      const res = await x.json();
      console.log(res);
      if (res.statusCode === 400) {
        toast.error(res.message, {});
        setDidJoinNewsletter(true);
      } else {
        await emailjs
          .send(
            'service_h4br5is',
            'template_3bi0wub',
            { name, email },
            { publicKey: 'grg76XmeXnwqwv5cy' }
          )
          .then(
            (response) => {
              console.log('SUCCESS!', response.status, response.text);
            },
            (error) => {
              console.log('FAILED...', error);
            }
          );
      }
      navigate('/thanks');
    } catch (error) {
      console.log(error);
      toast('An error has occured , Try Again Later', {
        icon: '⚠️',
      });
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const [ref1, inView1] = useInView({ triggerOnce: true });
  return (
    <motion.div
      className='footer'
      ref={ref1}
      initial={{ opacity: 0, scale: 0.8 }}
      animate={inView1 ? { opacity: 1, scale: 1 } : {}}
      transition={{ duration: 0.8 }}>
      <div id='NewsPaper'>
        <p
          className='first-to-know'
          style={{ textAlign: 'center', marginTop: 0 }}>
          SUBSCRIBE TO OUR NEWSLETTER TO STAY UPDATED!
        </p>
        <input
          value={name}
          onChange={(e) => setName(e.target.value)}
          type='text'
          placeholder='Name'
          className='footer-input'
          disabled={didJoinNewsletter}
        />
        <input
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          type='email'
          placeholder='Email'
          className='footer-input'
          disabled={didJoinNewsletter}
        />
        <motion.div
          whileHover={!didJoinNewsletter ? { scale: 1.2 } : {}}
          animate={
            didJoinNewsletter
              ? {
                  scale: [1, 1.2, 1],
                  transition: { duration: 0.5 },
                }
              : {}
          }
          transition={{ type: 'spring', stiffness: 500, damping: 30 }}
          className='subscribe-btn'
          style={{
            marginTop: 15,
            opacity: loading ? 0.5 : 1,
            cursor: didJoinNewsletter ? 'default' : 'pointer',
          }}
          onClick={() =>
            didJoinNewsletter
              ? null
              : !email.trim() || !name.trim() || !isValidEmail(email)
              ? toast('Please enter your name & email', { icon: '⚠️' })
              : joinNewsLetter()
          }>
          {loading ? (
            <Spin
              indicator={
                <LoadingOutlined
                  style={{
                    fontSize: 24,
                    color: 'white',
                  }}
                  spin
                />
              }
            />
          ) : (
            <motion.p
              initial={false}
              animate={
                didJoinNewsletter
                  ? {
                      scale: [1, 1.2, 1],
                    }
                  : {}
              }
              transition={{ duration: 0.5 }}>
              {didJoinNewsletter ? '✓ SUBSCRIBED!' : 'SUBSCRIBE'}
            </motion.p>
          )}
        </motion.div>
      </div>

      <div>
        <div className='flex'>
          <a
            href='https://www.instagram.com/thebookerapp?igsh=OWEwYXg5YjQ0NXQx'
            target='_blank'
            rel='noreferrer'>
            <Instagram width={30} height={30} />
          </a>
          <a
            href='https://www.facebook.com/profile.php?id=61558283653706'
            target='_blank'
            rel='noreferrer'>
            <Facebook width={30} height={30} />
          </a>
          <a
            href='https://www.tiktok.com/@thebooker.app?_t=8laJs404Hl2&_r=1'
            target='_blank'
            rel='noreferrer'>
            <Tiktok width={30} height={30} />
          </a>
        </div>
        <p>TheBooker App. All Rights Reserved.</p>
      </div>
    </motion.div>
  );
};

export default Footer;
